import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=48947b14&scoped=true&"
import script from "./CustomSwitch.vue?vue&type=script&lang=ts&"
export * from "./CustomSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=48947b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48947b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
